import React from 'react';
import { Description, Image, SubTitle } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';

const track = getTrack({ block: 26 });

const IMAGES = [buildImageURL('/lens-phone-h.jpg')];

export function LensPack2({ mobile = false }) {
  const wrapperTranslate = React.useMemo(() => {
    return mobile ? `translate(-50%, 10%) translateZ(0)` : `translate(50%, 19.746%) translateZ(0)`;
  }, [mobile]);
  return (
    <div className="page-section section-lens_pack_static inverted" data-track={track}>
      <div className="sticky-content">
        <div className="section-view">
          <div className="section-content left">
            <SubTitle>
              <span className="unknown-title-type">相机Mix</span>
              <br />
              高光时刻，
              <br />
              随时就位。
            </SubTitle>
            <Description>创造性的将每一颗镜头和拍摄模式以可见和随意组合的方式装进你的口袋。</Description>
          </div>
          <div className="phone-wrapper" style={{ transform: `${wrapperTranslate}` }}>
            <Image className="phone" src={IMAGES[0]} />
          </div>
        </div>
      </div>
    </div>
  );
}
